// Typelizer digest b9607819c92126ce5d4371f938c218f9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /incoming_email_allowed_senders */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/incoming_email_allowed_senders', {}, options),
    method: 'get',
  }),

  /** POST /incoming_email_allowed_senders */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/incoming_email_allowed_senders', {}, options),
    method: 'post',
  }),

  /** DELETE /incoming_email_allowed_senders/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/incoming_email_allowed_senders/:id', params, options),
    method: 'delete',
  }),
}
